import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import axios from "axios";
import Footer from "../main/Footer";
import { isAutheticated } from "../auth/authhelper";
import { API } from "../../API";

export default function ProductClicks() {
    const { token } = isAutheticated();
    // dhufhurh
    const [data, setData] = useState([]);
    const [showData, setShowData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(15);

    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [paying, setPaying] = useState(false)
    const [refreshToggle, setRefreshToggle] = useState(false)
    const loadData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${API}/api/analytics/Product_click/getAll`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log("heellkd", res.data?.data)
            setData(res.data.data || []);

        } catch (err) {
            console.error("Failed to load data", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, [refreshToggle]);
    // const commissionPercentage =
    //     data.channelType === "subchannel"
    //         ? data?.subchannelChannel?.my_comission
    //         : data.channelType === "networkChannel"
    //             ? data?.networkChannel?.commission?.networkChannelCommission
    //             : data?.SoComAdvisor;

    // console.log("commision", data)
    // Pagination logic
    useEffect(() => {
        const indexOfLast = currentPage * itemPerPage;
        const indexOfFirst = indexOfLast - itemPerPage;
        setShowData(data.slice(indexOfFirst, indexOfLast));
    }, [data, currentPage, itemPerPage]);

    const totalPages = Math.ceil(data.length / itemPerPage);

    // Dynamic "Showing X to Y of Z" calculation
    const firstEntry = data.length === 0 ? 0 : (currentPage - 1) * itemPerPage + 1;
    const lastEntry = Math.min(currentPage * itemPerPage, data.length);

    const openClicksModal = (item) => {
        setSelectedItem(item);
        setShowModal(true);
    };

    const formatUSDateTime = (date) => {
        if (!date) return "—";
        return new Date(date).toLocaleString("en-US", {
            month: "short", day: "2-digit", year: "numeric",
            hour: "2-digit", minute: "2-digit", hour12: true,
            timeZone: "America/New_York",
        });
    };
    const handleCommissionPayment = async () => {
        if (!selectedItem) return;

        // 1. Calculate Commission and identify Channel Type
        const type = selectedItem.channelType; // subChannel, networkChannel, or SoComAdvisor
        let commissionPercent = 0;

        if (type === "subChannel") {
            commissionPercent = selectedItem?.subchannelChannel?.my_comission || 0;
        } else if (type === "networkChannel") {
            commissionPercent = selectedItem?.networkChannel?.commission?.networkChannelCommission || 0;
        } else {
            commissionPercent = selectedItem?.SoComAdvisor?.advisorCommission || 0;
        }

        const rawPrice = Number(selectedItem?.price?.toString().replace(/[^0-9.]/g, "")) || 0;
        const commissionAmount = Number(((rawPrice * Number(commissionPercent)) / 100).toFixed(2));
        const currency = selectedItem?.price?.toString().match(/^[^\d]+/)?.[0] || "$";

        if (commissionAmount <= 0) {
            return Swal.fire({
                title: "Invalid Amount",
                text: `The commission for ${selectedItem.productName} is 0. Payment cannot be processed.`,
                icon: "warning",
            });
        }

        const displayChannelName =
            type === "subChannel" ? (selectedItem?.subchannelChannel?.name || "Channel") :
                type === "networkChannel" ? (selectedItem?.networkChannel?.name || "Network Channel") :
                    (selectedItem?.SoComAdvisor?.name || "SoCom Advisor");

        // 2. Pass it into the Swal configuration
        const result = await Swal.fire({
            title: "Confirm Commission Payment",
            html: `
        <div style="text-align: left; padding: 0 10px;">
            <p style="margin-bottom: 8px;">
                <strong>Product:</strong> ${selectedItem.productName}
            </p>
            <p style="margin-bottom: 8px;">
                <strong>Recipient:</strong> ${displayChannelName} 
            </p>
            <p style="margin-bottom: 0;">
                <strong>Total Commission:</strong> 
                <span style="color: #28a745; font-weight: bold;">
                    ${currency}${commissionAmount}
                </span>
            </p>
        </div>`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Proceed to Stripe",
        });


        // const result = await Swal.fire({
        //     title: "Confirm Commission Payment",
        //     html: `<div style="text-align: left;">
        //         <p><strong>Product:</strong> ${selectedItem.productName}</p>
        //         <p><strong>Total Commission:</strong> <span style="color: #28a745; font-weight: bold;">${currency}${commissionAmount}</span></p>
        //     </div>`,
        //     icon: "question",
        //     showCancelButton: true,
        //     confirmButtonText: "Proceed to Stripe",
        // });

        if (!result.isConfirmed) return;

        setPaying(true);

        try {
            // --- DYNAMIC PAYLOAD CONSTRUCTION ---
            const paymentPayload = {
                clickId: selectedItem._id,
                clickSerialNumber: selectedItem.serialNumber, // Added serial number
                productName: selectedItem.productName,
                commissionAmount: commissionAmount,
                currency: currency === "$" ? "usd" : currency.toLowerCase().trim(),
                channelType: type,
                BaseUrl: "https://admin.socomott.com",

                // Video Info
                videoId: selectedItem.videoID?._id,
                videoTitle: selectedItem.videoID?.title || "N/A",
            };

            // Conditional Data Logic
            if (type === "subChannel") {
                paymentPayload.subChannel = selectedItem.subchannelChannel;
                paymentPayload.networkChannel = selectedItem.networkChannel;
                paymentPayload.SoComAdvisor = selectedItem.SoComAdvisor;
            }
            else if (type === "networkChannel") {
                paymentPayload.networkChannel = selectedItem.networkChannel;
                paymentPayload.SoComAdvisor = selectedItem.SoComAdvisor;
            }
            else if (type === "SoComAdvisor") {
                paymentPayload.SoComAdvisor = selectedItem.SoComAdvisor;
            }

            const res = await axios.post(
                `${API}/api/analytics/payment/commission_payment/create`,
                paymentPayload,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (res.data?.url) {
                window.location.href = res.data.url;
            }
        } catch (err) {
            console.error("Payment Error:", err);
            Swal.fire("Error", "Could not initiate payment.", "error");
        } finally {
            setPaying(false);
        }
    };


    const handleStatusChange = async (recordId, newStatus) => {
        if (!recordId) return;

        // 1. Get the label for the status from your config
        const statusLabel = STATUS_CONFIG[newStatus]?.label || newStatus;

        // 2. Show Warning/Confirmation Dialog
        const result = await Swal.fire({
            title: "Are you sure?",
            text: `Do you want to change the status to: ${statusLabel}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6", // Primary Blue
            cancelButtonColor: "#d33",    // Danger Red
            confirmButtonText: "Yes, update it!",
            cancelButtonText: "Cancel"
        });

        // 3. If user clicked "Cancel", stop the function
        if (!result.isConfirmed) return;

        try {
            // 4. Proceed with API call
            const response = await axios.patch(`${API}/api/analytics/status-update/${recordId}`, {
                status: newStatus
            });

            if (response.data.success) {
                // 5. Show Success Message
                Swal.fire({
                    title: "Updated!",
                    text: `Status is now: ${statusLabel}`,
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });

                // 6. Trigger data reload
                setRefreshToggle(prev => !prev);
            }
        } catch (error) {
            console.error("Update Error:", error);

            Swal.fire({
                title: "Error",
                text: error.response?.data?.message || "Failed to update status",
                icon: "error",
            });
        }
    };


    const STATUS_CONFIG = {
        pending: {
            label: "Pending for Verification",
            className: "bg-warning text-dark", // Yellow/Orange
        },
        viewer_paid: {
            label: "Viewer PAID on External eComm",
            className: "bg-primary text-white", // Blue
        },
        viewer_not_paid: {
            label: "Viewer NOT PAID on External eComm",
            className: "bg-danger", // Red
        },
        paid: {
            label: "Platform Commission PAID",
            className: "bg-success", // Green
        },
        commission_not_paid: {
            label: "Platform Commission NOT PAID",
            className: "bg-danger", // Red
        },
        failed: {
            label: "Failed",
            className: "bg-secondary",
        },
    };
    return (
        <div div className="main-content">
            <style >
                {`

                @media print {

  body * {
    visibility: hidden;
  }

  .print-container,
  .print-container * {
    visibility: visible;
  }

  .print-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    min-height: 100vh;
    font-size: 20px;
    line-height: 2rem;
    padding: 10px;
  }

  .modal-dialog {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 !important;
  }

  .modal-content {
    border: none !important;
    box-shadow: none !important;
  }

  /* Keep two columns */
  .row {
    display: flex !important;
    flex-wrap: wrap !important;
  }

  .col-md-6 {
    width: 50% !important;
    flex: 0 0 50% !important;
  }

  /* Increase section spacing */
  .bg-light {
    padding: 12px !important;
    margin-bottom: 12px !important;
  }

  h5 {
    font-size: 24px;
  }

  h6 {
    font-size: 19px;
  }

  p, strong {
    font-size: 18px;
  }

  img {
    width: 120px !important;
    height: 120px !important;
  }

  .no-print {
    display: none !important;
  }

  @page {
    size: A4;
    margin: 8mm;
  }

}
       `}
            </style >

            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title & Breadcrumb */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Video Popup Click Transactions</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><Link to="/dashboard">SoComOTT</Link></li>
                                        <li className="breadcrumb-item active">Analytics</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="d-flex align-items-center">
                                        Show
                                        <select
                                            value={itemPerPage}
                                            onChange={(e) => { setItemPerPage(Number(e.target.value)); setCurrentPage(1); }}
                                            className="custom-select custom-select-sm mx-2"
                                            style={{ width: "80px" }}
                                        >
                                            <option value="15">15</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                        </select>
                                        entries
                                    </label>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-centered table-hover mb-0">
                                    <thead className="thead-light text-center">
                                        <tr>
                                            <th>#</th>
                                            <th>Click Serial No.</th>
                                            <th>Click Date</th>

                                            <th>Product Name</th>
                                            <th>Video</th>
                                            <th>Network Channel</th>
                                            <th>Channel</th>

                                            <th>Current Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        {loading ? (
                                            <tr><td colSpan="5">Loading...</td></tr>
                                        ) : showData.map((item, index) => (
                                            <tr key={item._id}>
                                                <td className="">
                                                    {(currentPage - 1) * itemPerPage + (index + 1)}
                                                </td>
                                                <td className="">{item?.serialNumber}</td>
                                                <td>{formatUSDateTime(item.createdAt)}</td>

                                                {/* font-weight-bold */}
                                                <td className="">{item.productName}</td>
                                                <td>{item.videoID?.title || "—"}</td>

                                                <td>{item.networkChannel?.name || "—"}</td>
                                                <td>{item.subchannelChannel?.name || "—"}</td>

                                                {/* <td className="text-center">
                                                    <span className={`badge ${item.paymentStatus === "paid"
                                                        ? "bg-success"  // Green for Paid
                                                        : "bg-warning text-dark" // Yellow for Pending (text-dark helps readability on yellow)
                                                        }`}>
                                                        {item.paymentStatus === "paid" ? "Paid" : "Pending"}
                                                    </span>

                                                </td> */}
                                                <td className="text-center">
                                                    {(() => {
                                                        // Fallback to 'pending' if status is undefined or not in the list
                                                        const config = STATUS_CONFIG[item.paymentStatus] || STATUS_CONFIG.pending;

                                                        return (
                                                            <span className={`badge ${config.className} px-3 py-2`}>
                                                                {config.label}
                                                            </span>
                                                        );
                                                    })()}
                                                </td>
                                                <td className="text-center">
                                                    <span
                                                        className="text-primary font-weight-medium cursor-pointer"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => openClicksModal(item)}
                                                        onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                                        onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                                                    >
                                                        View
                                                    </span>
                                                </td>

                                                {/* <td>{item.paymentStatus === "pending" ? "Pending"}</td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Corrected Pagination Display */}
                            <div className="row mt-4">
                                <div className="col-sm-12 col-md-5">
                                    <p className="text-muted">
                                        Showing {firstEntry} to {lastEntry} of {data.length} entries
                                    </p>
                                </div>
                                <div className="col-sm-12 col-md-7">
                                    <ul className="pagination justify-content-end mb-0">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>Previous</button>
                                        </li>
                                        {[...Array(totalPages)].map((_, i) => (
                                            <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                                                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>Next</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal - Integrated with your custom fields */}
            {
                showModal && selectedItem && (
                    <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content print-container">
                                <div className="print-title mb-2">

                                    {/* Title Row */}
                                    <h5 className="font-weight-bold ms-2 mt-2 mb-3">
                                        Video Popup Click Transactions
                                    </h5>
                                    <hr />
                                    {/* Product + Buttons Row */}
                                    <div className="d-flex justify-content-between align-items-center flex-wrap mr-2">
                                        <div className="no-print">
                                            <button
                                                className="btn btn-sm btn-secondary mr-2"
                                                onClick={() => setShowModal(false)}
                                            >
                                                Back
                                            </button>

                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={() => window.print()}
                                            >
                                                Print
                                            </button>
                                        </div>
                                        {/* Product Name */}
                                        <div className="  px-3 py-1">
                                            <strong>Product:</strong>{" "}
                                            <span className="text-primary font-weight-bold">
                                                {selectedItem.productName}
                                            </span>
                                        </div>

                                        {/* Buttons */}


                                    </div>
                                    <hr />
                                </div>



                                {/* <div className="modal-footer no-print d-flex justify-content-between align-items-center">
                                <div>
                                    <p className="mb-0 font-weight-bold" style={{ fontSize: '1.1rem' }}>
                                        Product: <span className="text-primary">{selectedItem.productName}</span>
                                    </p>
                                </div>

                               
                            </div> */}
                                <div className="modal-body p-4">

                                    {/* Click Details */}
                                    <div className="bg-light border rounded p-3 mb-3">
                                        <h6 className="border-bottom pb-1 text-muted font-weight-bold small ">
                                            Click Details
                                        </h6>

                                        <div className="row mt-2">
                                            <div className="col-md-6 mb-2">
                                                <strong>Click Serial No.:</strong>
                                                <span className="text-primary font-italic ml-1">
                                                    {selectedItem.serialNumber}
                                                </span>
                                            </div>

                                            <div className="col-md-6 mb-2">
                                                <strong>Clicked Date and Time:</strong>{" "}
                                                {formatUSDateTime(selectedItem.createdAt)}
                                            </div>

                                            <div className="col-md-6 mb-2">
                                                <strong>IP:</strong> {selectedItem.ipAddress}
                                            </div>

                                            <div className="col-md-6">
                                                <strong>City ( Country ):</strong>{" "}
                                                {selectedItem.city}{" "} ( {selectedItem.country} )
                                            </div>
                                        </div>
                                    </div>


                                    {/* Channel Details */}
                                    <div className="bg-light border rounded p-3 mb-3">
                                        <h6 className="border-bottom pb-1 text-muted font-weight-bold small ">
                                            Channel Details
                                        </h6>

                                        <div className="row mt-2">
                                            <div className="col-md-6 mb-2"><strong>Referral Agent Name:</strong> —</div>
                                            <div className="col-md-6 mb-2"><strong>Referral Agent Email:</strong> —</div>

                                            <div className="col-md-6 mb-2">
                                                <strong>Network Channel Name:</strong>{" "}
                                                {selectedItem.networkChannel?.name || "—"}
                                            </div>

                                            <div className="col-md-6 mb-2">
                                                <strong>Channel Name:</strong>{" "}
                                                {selectedItem.channelType === "subChannel"
                                                    ? selectedItem.subchannelChannel?.name
                                                    : "N/A"}
                                            </div>

                                            <div className="col-md-6 mb-2">
                                                <strong>Network Channel Administrator:</strong>{" "}
                                                {selectedItem.networkChannel?.userID?.name || "—"}
                                            </div>

                                            <div className="col-md-6 mb-2">
                                                <strong>Channel Administrator:</strong>{" "}
                                                {selectedItem.subchannelChannel?.userID?.name || "—"}
                                            </div>

                                            <div className="col-md-6">
                                                <strong>Network Channel Admin Email:</strong>{" "}
                                                {selectedItem.networkChannel?.userID?.email || "—"}
                                            </div>

                                            <div className="col-md-6">
                                                <strong>Channel Admin Email:</strong>{" "}
                                                {selectedItem.subchannelChannel?.userID?.email || "—"}
                                            </div>
                                        </div>
                                    </div>


                                    {/* Transaction Verification */}







                                    <div className="bg-light border rounded p-3 mb-3">
                                        {/* <h6 className="border-bottom pb-1 text-muted font-weight-bold small">
                                            Transaction Verification
                                        </h6> */}
                                        <h6 className="border-bottom pb-1 text-muted font-weight-bold small d-flex justify-content-between align-items-center">
                                            <span>Transaction Verification</span>

                                            <div className="d-flex align-items-center">
                                                {/* Increased from 10px to 12px for better readability */}
                                                <span className="mr-2 " style={{ fontSize: '12px', fontWeight: '500' }}>
                                                    Current Status:
                                                </span>

                                                {(() => {
                                                    const statusKey = selectedItem?.paymentStatus || 'pending';
                                                    const config = STATUS_CONFIG[statusKey] || STATUS_CONFIG.pending;

                                                    return (
                                                        <span
                                                            /* Added 'rounded' for that Bootstrap button feel and increased font to 11px/12px */
                                                            className={`badge border rounded ${config.className} font-weight-bold`}
                                                            style={{
                                                                fontSize: '13px',
                                                                padding: '5px 10px',
                                                                letterSpacing: '0.3px'
                                                            }}
                                                        >
                                                            {config.label}
                                                        </span>
                                                    );
                                                })()}
                                            </div>
                                        </h6>


                                        <div className="row mt-2 align-items-center">
                                            {/* Row 1: Viewer Paid on External */}
                                            <div className="col-md-12 mb-3 d-flex align-items-center">
                                                <strong>Viewer Paid on External eComm Market Place:</strong>
                                                <div>
                                                    {/* <button className="btn  btn-sm btn-success py-0 px-2 mr-1" style={{ fontSize: '10px' }}>YES</button>
                                                    <button className="btn btn-sm btn-danger py-0 px-2" style={{ fontSize: '10px' }}>NO</button> */}

                                                    <button
                                                        className="btn btn-sm btn-success py-0 px-2 mr-1"
                                                        style={{ fontSize: '10px' }}
                                                        disabled={true}

                                                        onClick={() => handleStatusChange(selectedItem._id, "viewer_paid")}
                                                    >
                                                        YES
                                                    </button>

                                                    {/* NO Button: Sets status to viewer_not_paid */}
                                                    <button
                                                        className="btn btn-sm btn-danger py-0 px-2"
                                                        style={{ fontSize: '10px' }}
                                                        disabled={true}
                                                        onClick={() => handleStatusChange(selectedItem._id, "viewer_not_paid")}
                                                    >
                                                        NO
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Row 2: Price and Currency */}
                                            <div className="col-md-6 mb-2">
                                                <strong>Price: </strong>{selectedItem.price}
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <strong>Currency: </strong>{selectedItem?.price?.toString().match(/^[^\d]+/)?.[0] || "-"}
                                            </div>

                                            {/* Row 3: Quantity and Value in Currency */}
                                            <div className="col-md-6 mb-2">
                                                <strong>Quantity: </strong>1
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <strong>Value in Currency: </strong>{selectedItem.price}
                                            </div>

                                            {/* Row 4: Commission % and Amount */}
                                            <div className="col-md-6 mb-2">
                                                <strong>Commission To Pay Percentage: </strong>
                                                <span className="">
                                                    {selectedItem.channelType === "subChannel"
                                                        ? (Number(selectedItem?.subchannelChannel?.my_comission) ?? "-")
                                                        : selectedItem.channelType === "networkChannel"
                                                            ? (selectedItem?.networkChannel?.commission?.networkChannelCommission ?? "-")
                                                            : (selectedItem?.SoComAdvisor?.advisorCommission ?? "-")}
                                                    %
                                                </span>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <strong>Commission Amount: </strong>
                                                <span className="">
                                                    {selectedItem?.price?.toString().match(/^[^\d]+/)?.[0]}
                                                    {((Number(selectedItem?.price?.toString().replace(/[^0-9.]/g, "")) || 0) * (Number(
                                                        selectedItem.channelType === "subChannel"
                                                            ? selectedItem?.subchannelChannel?.my_comission
                                                            : selectedItem.channelType === "networkChannel"
                                                                ? selectedItem?.networkChannel?.commission?.networkChannelCommission
                                                                : selectedItem?.SoComAdvisor?.advisorCommission
                                                    ) || 0) / 100).toFixed(2)}
                                                </span>
                                            </div>

                                            {/* Row 5: Release Invoice Buttons */}
                                            <div className="col-md-12  d-flex align-items-center ">
                                                <strong>Release Invoice to Pay Commission:</strong>
                                                <div>
                                                    <button
                                                        className={`btn btn-sm py-0 px-2 mr-1 ${selectedItem.paymentStatus === "paid"
                                                            ? "btn-primary"  // Gray color if paid
                                                            : "btn-success"    // Green color if unpaid
                                                            }`}
                                                        style={{ fontSize: '11px' }}
                                                        // onClick={handleCommissionPayment}
                                                        // disabled={selectedItem.paymentStatus === "paid" || paying}
                                                        disabled={true}

                                                    >
                                                        {paying
                                                            ? "REDIRECTING..."
                                                            : selectedItem.paymentStatus === "paid"
                                                                ? "ALREADY PAID"
                                                                : "YES"
                                                        }
                                                    </button>
                                                    <button className="btn btn-sm btn-danger py-0 px-2"
                                                        //  onClick={() => handleStatusChange(selectedItem._id, "commission_not_paid")}
                                                        disabled={true}
                                                        onClick={() => { }}
                                                        style={{ fontSize: '11px' }}>NO</button>
                                                    {/* <button
                                                        className="btn btn-sm btn-danger py-0 px-2"
                                                        style={{ fontSize: '10px' }}
                                                        onClick={() => handleStatusChange(selectedItem._id, "commission_not_paid")}
                                                    >
                                                        NO
                                                    </button> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Video Details */}
                                    <div className="bg-light border rounded p-3 mb-3">
                                        <h6 className="border-bottom pb-1 text-muted font-weight-bold small">
                                            Video Details
                                        </h6>

                                        <p className="mb-1">
                                            <strong>Video Name:</strong>{" "}
                                            {selectedItem.videoID?.title || "—"}
                                        </p>

                                        <p className="mb-0">
                                            <strong>Video URL:</strong>{" "}
                                            <a
                                                href={selectedItem.frontend_website_Video_Url}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-primary text-break"
                                            >
                                                {selectedItem.frontend_website_Video_Url}
                                            </a>
                                        </p>
                                    </div>


                                    {/* Product Popup Parameters */}
                                    <div className="border-top pt-4">
                                        <h6 className="text-muted font-weight-bold small  mb-3">
                                            From Popup Parameters
                                        </h6>

                                        <div className="media">
                                            <img
                                                src={selectedItem.ProductThumbnail_Url}
                                                alt="Product"
                                                className="mr-3 rounded border"
                                                style={{ width: "110px", height: "110px", objectFit: "cover" }}
                                            />

                                            <div className="media-body">
                                                <h6 className="font-weight-bold">
                                                    Product Name: {selectedItem.productName}
                                                </h6>

                                                <p className="text-muted small">
                                                    <strong>Description:</strong> {selectedItem.Product_Description}
                                                </p>

                                                <div className="d-flex mb-2">
                                                    <div className="mr-4">
                                                        <strong>Price:</strong>{" "}
                                                        <span className="text-success font-weight-bold">
                                                            {selectedItem.price}
                                                        </span>
                                                    </div>

                                                    <div>
                                                        <strong>Button:</strong>{" "}
                                                        {selectedItem.Product_show_Button_Name}
                                                    </div>
                                                </div>

                                                <div className="bg-light p-2 border rounded small">
                                                    <strong>External eComm URL:</strong>
                                                    <a
                                                        href={selectedItem.external_ProductUrl}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="text-primary ml-1 text-break"
                                                    >
                                                        {selectedItem.external_ProductUrl}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                )
            }


        </div >

    )








}